import React, {useEffect } from 'react';

function Main(props) {
  useEffect(() => {
    const pageName = "main";
    console.log(props)
      if(pageName !== props.pageN.page) props.pageF(pageName)
  });
  return (
      <div></div>
  );
};
  
export default Main;